import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">
        This Privacy Policy outlines how we collect, use, store, and protect
        your personal information when you use our website, products, and
        services.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <p>
        <strong>a. Personal Information:</strong> Name, email address, phone
        number, and mailing address
      </p>
      <p>
        <strong>b. Technical Data:</strong> IP address, browser type and
        version, device information, usage data and analytics
      </p>
      <p>
        <strong>c. Cookies and Tracking Technologies:</strong> We use cookies
        and similar technologies to enhance user experience and analyze traffic.
        You can manage cookie preferences through your browser settings.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc pl-6">
        <li>Provide and improve our digital services</li>
        <li>Process transactions and send invoices</li>
        <li>Respond to inquiries and provide customer support</li>
        <li>Send marketing communications (with opt-out options)</li>
        <li>Ensure security and prevent fraud</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        3. Sharing Your Information
      </h2>
      <p>
        We do not sell your personal data. We may share your information with:
      </p>
      <ul className="list-disc pl-6">
        <li>
          Trusted service providers (hosting, payment processing, analytics)
        </li>
        <li>Legal authorities, when required by law</li>
        <li>Business partners in case of a merger, acquisition, or sale</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        4. Data Storage and Security
      </h2>
      <ul className="list-disc pl-6">
        <li>Encrypted transmission (SSL)</li>
        <li>Secure storage on protected servers</li>
        <li>Access controls and authentication protocols</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Your Rights</h2>
      <p>Depending on your location, you may have rights to:</p>
      <ul className="list-disc pl-6">
        <li>Access the personal data we hold about you</li>
        <li>Correct inaccurate information</li>
        <li>Request the deletion of your data</li>
        <li>Withdraw consent to processing</li>
        <li>Object to certain uses (e.g., direct marketing)</li>
        <li>Data portability</li>
      </ul>
      <p>
        To exercise these rights, please contact us at:{" "}
        <a href="mailto:info@pinnacleroute.com" className="text-blue-500">
          info@pinnacleroute.com
        </a>
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        6. International Data Transfers
      </h2>
      <p>
        We may process your data outside your country of residence. By using our
        services, you consent to such transfers, subject to appropriate
        safeguards.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Third-Party Links</h2>
      <p>
        Our website may contain links to third-party sites. We are not
        responsible for their privacy practices. Please review their privacy
        policies separately.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        8. Children's Privacy
      </h2>
      <p>
        Our services are not intended for children under 16. We do not knowingly
        collect data from minors. If we become aware of such data, we will
        delete it immediately.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        9. Changes to This Policy
      </h2>
      <p>
        We may update this Privacy Policy periodically. Any changes will be
        posted on this page with a new effective date. We encourage users to
        review this policy regularly.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">10. Contact Us</h2>
      <p>
        If you have questions or concerns about this Privacy Policy, please
        contact us:
      </p>
      <p>
        Email:{" "}
        <a href="mailto:info@pinnacleroute.com" className="text-blue-500">
          info@pinnacleroute.com
        </a>
      </p>
      <p>
        Website:{" "}
        <a
          href="https://www.pinnacleroute.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500"
        >
          https://www.pinnacleroute.com
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
